<nav class="nav nav-secondary mixed-loyalty-nav">
  <a
    attr.aria-label="{{ 'home.nav.screenreader' | translate }}"
    class="nav-item"
    [routerLink]="['/']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <label>{{ 'home.nav' | translate }}</label>
  </a>
  <a
    class="nav-item"
    [routerLink]="['/rewards']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'rewards.nav.screenreader' | translate : { fgbdefault: 'Move to rewards page' } }}"
  >
    <label>{{ 'rewards.nav' | translate }}</label>
  </a>
  <a
    class="nav-item"
    [routerLink]="['/challenges']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'challenges.nav.screenreader' | translate : { fgbdefault: 'Move to challenges page' } }}"
  >
    <label>{{ 'challenges.nav' | translate }}</label>
  </a>
  <a
    class="nav-item"
    [routerLink]="['/games']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'games.nav.screenreader' | translate : { fgbdefault: 'Move to games page' } }}"
  >
    <label>{{ 'games.nav' | translate }}</label>
  </a>
</nav>
